import React, { useEffect } from "react";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";
import config from "../configs/chatbotConfig";
import Chatbot from "react-chatbot-kit";
import AIMessageParser from "../chatbot/AIMessageParser";
import AIActionProvider from "../chatbot/AIActionProvider.js";
import { createClientMessage } from "react-chatbot-kit";

const StrutsAI = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    createClientMessage("Hello there.");
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      {/* Hero Section */}
      <section className="hero-modern product-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Unleash the Power of
                <span className="gradient-text"> AI</span>
              </h1>
              <p className="hero-subtitle">
                Revolutionize Your Business with Automated Chat Solutions. Train
                Your Personal Assistant to Engage Customers and Boost Sales.
              </p>
              <div className="hero-actions">
                <a
                  href="https://ai.strutstechnology.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                >
                  Get Started Free
                </a>
                <a
                  href="https://twitter.com/StrutsAI"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-outline"
                >
                  <span className="icon">🐦</span>
                  Follow @StrutsAI
                </a>
              </div>
            </div>
            <div className="hero-visual">
              <div className="dashboard-preview">
                <img
                  src="/assets/code-bg.jpg"
                  alt="Struts AI Dashboard"
                  className="hero-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">AI-Powered Business Solutions</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🤖</div>
              <h3>Smart Chatbots</h3>
              <p>
                Train intelligent chatbots to handle customer queries, gather
                information, and provide 24/7 support
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3>Custom Conversations</h3>
              <p>
                Craft tailored interactions that match your brand voice and
                capture valuable customer details
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Sales Automation</h3>
              <p>
                Automate lead generation, follow-ups, and sales processes to
                maximize conversion rates
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Targeted Engagement</h3>
              <p>
                Engage customers with personalized messages and recommendations
                based on their behavior
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Analytics & Insights</h3>
              <p>
                Get detailed analytics on customer interactions and chatbot
                performance
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Easy Integration</h3>
              <p>
                Seamlessly integrate with your existing systems and workflows
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Customer Support?</h2>
            <p>
              Join thousands of businesses already using Struts AI to automate
              and prosper
            </p>
            <div className="cta-actions">
              <a
                href="https://ai.strutstechnology.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary large"
              >
                Start Free Trial
              </a>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default StrutsAI;
